/* ==========================================================================
   REMY mockup — vanilla JS only.
   Scope is deliberately limited to interactions that have a direct Kalles
   equivalent: the mobile nav toggle, the PDP accordions, the size-guide
   popup, the cart drawer, instant search and the announcement rotation. No framework, no build step.
   The ONLY persistent state is the bag, in localStorage — there is no
   backend, and that is the whole reason it lives there.
   ONE fetch exists — the size-guide modal pulls the chart page, mirroring the
   theme's own AJAX popup, and falls back to plain navigation if it cannot.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Mobile nav toggle  →  Kalles drawer equivalent ------------------- */
  var burger = document.getElementById('burger');
  var mobileNav = document.getElementById('mobile-nav');

  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      if (mobileNav.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
    });
  }


  /* ---- MEGA MENU (desktop, hover) --------------------------------------
     Opens a full-width overlay for Boys / Girls. Stays open while the pointer
     is over either the nav item or the panel; closes on mouse-out of both,
     on Escape, and on focus leaving the header. */
  var header = document.querySelector('.header');
  var megaItems = document.querySelectorAll('.nav__item--mega');
  var megaPanels = document.querySelectorAll('[data-mega-panel]');
  var megaTimer = null;
  var DESKTOP = function () { return window.matchMedia('(min-width: 901px)').matches; };

  function closeMega() {
    megaPanels.forEach(function (p) { p.classList.remove('is-open'); });
    megaItems.forEach(function (i) {
      var a = i.querySelector('.nav__link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  }
  function openMega(key) {
    megaPanels.forEach(function (p) {
      p.classList.toggle('is-open', p.getAttribute('data-mega-panel') === key);
    });
    megaItems.forEach(function (i) {
      var a = i.querySelector('.nav__link');
      if (a) a.setAttribute('aria-expanded', String(i.getAttribute('data-mega') === key));
    });
  }
  function scheduleClose() { clearTimeout(megaTimer); megaTimer = setTimeout(closeMega, 140); }
  function cancelClose() { clearTimeout(megaTimer); }

  megaItems.forEach(function (item) {
    var key = item.getAttribute('data-mega');
    item.addEventListener('mouseenter', function () { if (DESKTOP()) { cancelClose(); openMega(key); } });
    item.addEventListener('mouseleave', function () { if (DESKTOP()) scheduleClose(); });
    // keyboard access
    var link = item.querySelector('.nav__link');
    if (link) link.addEventListener('focus', function () { if (DESKTOP()) openMega(key); });
  });
  megaPanels.forEach(function (panel) {
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', function () { if (DESKTOP()) scheduleClose(); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });
  if (header) header.addEventListener('focusout', function (e) {
    if (!header.contains(e.relatedTarget)) closeMega();
  });

  /* ---- MOBILE SLIDE-IN PANEL -------------------------------------------
     NB the scrim variables across this file are named per component on
     purpose. Everything here shares ONE function scope (the IIFE), and `var`
     is function-scoped and hoisted — so two `var scrim` declarations do not
     make two variables, they make one, and whichever assignment runs last at
     init wins for every caller. That exact bug shipped: the cart's
     `var scrim` clobbered the nav's, so opening the burger menu raised the
     CART scrim (z-index 90) over the mobile nav (z-index 80) and made every
     link in the menu unclickable. Keep these names distinct. */
  var mnavScrim = document.querySelector('.mnav-scrim');

  function openDrawer() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    if (mnavScrim) reveal(mnavScrim);  // same reveal path as the other overlays
    if (burger) { burger.setAttribute('aria-expanded', 'true'); burger.setAttribute('aria-label', 'Close menu'); }
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    if (mnavScrim) { mnavScrim.classList.remove('is-open'); setTimeout(function () { mnavScrim.hidden = true; }, 300); }
    if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.setAttribute('aria-label', 'Open menu'); }
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-mnav-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---- MOBILE TREE ACCORDIONS ------------------------------------------ */
  document.querySelectorAll('.mnav__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      if (!sub) return;
      var open = sub.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---- Accordions  →  Kalles product tab/accordion equivalent ----------- */
  var triggers = document.querySelectorAll('.acc__trigger');

  Array.prototype.forEach.call(triggers, function (trigger) {
    trigger.addEventListener('click', function () {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      var open = panel.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---- Size / colour selectors -----------------------------------------
     Still no variant lookup, no price change and no inventory read — every
     product is a single Size option at one price (see build/render_product).
     The selection is no longer purely decorative though: Add to Bag reads the
     active chip's data-size, and `is-disabled` chips are skipped here, which
     is what keeps a sold-out size from ever becoming the active one. */
  document.querySelectorAll('[data-select-group]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var chip = e.target.closest('.size-chip, .swatch-lg');
      if (!chip || chip.classList.contains('is-disabled')) return;
      group.querySelectorAll('.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
      chip.classList.add('is-active');
    });
  });


  /* ---- LOAD MORE  →  Kalles: [data-load-more] on main-collection ---------
     Reveals the next batch of cards (batch size = the theme's own 50/page
     limit). Reveal-based rather than re-render, so a card can never be
     duplicated. Button removes itself once the collection is exhausted. */
  document.querySelectorAll('[data-load-more]').forEach(function (btn) {
    var grid = document.querySelector('.grid-products');
    if (!grid) return;
    var batch = parseInt(btn.getAttribute('data-batch'), 10) || 50;
    btn.addEventListener('click', function () {
      var hidden = grid.querySelectorAll('.pcard[hidden]');
      var n = Math.min(batch, hidden.length);
      for (var i = 0; i < n; i++) hidden[i].hidden = false;
      var left = grid.querySelectorAll('.pcard[hidden]').length;
      btn.setAttribute('data-remaining', String(left));
      if (left === 0) {
        btn.parentNode.removeChild(btn);
      } else {
        var c = btn.querySelector('.loadmore__count');
        if (c) c.textContent = '(' + left + ' remaining)';
      }
    });
  });


  /* ---- GALLERY "+N more" reveal (products with many images) ------------- */
  document.querySelectorAll('[data-gallery-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var g = btn.closest('.gallery');
      if (!g) return;
      g.classList.add('is-expanded');
      btn.parentNode.removeChild(btn);
    });
  });


  /* ---- SIZE GUIDE  →  Kalles: a.t4s-btn__size-chart (AJAX popup) ---------
     The live theme opens the product's own size-chart page in a modal over
     the PDP. Same here, but PROGRESSIVE: the anchor carries a real href to
     page-<chart>.html, and the modal only takes over when it can actually
     fetch. Opened from file:// (no fetch) or on a failed request, the click
     just follows the link — the size chart is never unreachable. */
  var sgTriggers = document.querySelectorAll('[data-size-guide]');
  if (sgTriggers.length && location.protocol !== 'file:' && window.fetch) {
    var sgModal = null, sgLastFocus = null;

    function sgBuild() {
      var m = document.createElement('div');
      m.className = 'sg';
      m.hidden = true;
      m.innerHTML =
        '<div class="sg__scrim" data-sg-close></div>' +
        '<div class="sg__panel" role="dialog" aria-modal="true" aria-labelledby="sg-title">' +
          '<div class="sg__head">' +
            '<h2 class="h3 sg__title" id="sg-title"></h2>' +
            '<button class="sg__close" type="button" data-sg-close aria-label="Close size guide">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="sg__body"></div>' +
          '<a class="sg__full" href="#">Open the full size chart</a>' +
        '</div>';
      document.body.appendChild(m);
      m.addEventListener('click', function (e) {
        if (e.target.closest('[data-sg-close]')) sgClose();
      });
      return m;
    }
    function sgClose() {
      if (!sgModal) return;
      sgModal.classList.remove('is-open');
      sgModal.hidden = true;
      document.body.style.overflow = '';
      if (sgLastFocus) sgLastFocus.focus();
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sgModal && !sgModal.hidden) sgClose();
    });

    Array.prototype.forEach.call(sgTriggers, function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href) return;
        e.preventDefault();
        sgLastFocus = a;
        if (!sgModal) sgModal = sgBuild();
        sgModal.querySelector('.sg__title').textContent =
          a.getAttribute('data-chart-title') || 'Size guide';
        sgModal.querySelector('.sg__full').setAttribute('href', href);
        sgModal.querySelector('.sg__body').innerHTML = '<p class="sg__loading">Loading…</p>';
        reveal(sgModal);
        document.body.style.overflow = 'hidden';
        sgModal.querySelector('.sg__close').focus();

        fetch(href).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var table = doc.querySelector('.table-scroll');
          if (!table) throw new Error('no table');
          var body = sgModal.querySelector('.sg__body');
          body.innerHTML = '';
          var lede = doc.querySelector('.page__lede');
          if (lede) body.appendChild(lede.cloneNode(true));
          body.appendChild(table.cloneNode(true));
          Array.prototype.forEach.call(doc.querySelectorAll('.page__note'), function (n) {
            body.appendChild(n.cloneNode(true));
          });
        }).catch(function () {
          // never strand the user: fall back to the real page
          window.location = href;
        });
      });
    });
  }



  /* Reveal a panel that animates in from a hidden start state.

     `hidden = false` then `classList.add('is-open')` in the SAME task would
     give the transition no start value, so this used to schedule the class in
     requestAnimationFrame. That is fragile: rAF does not run while the page
     is not being rendered (background or occluded tab), and the panel then
     un-hides without ever sliding in — scrim up, no panel. Forcing a reflow
     flushes the start state synchronously, so the transition runs no matter
     how the frame loop is behaving. */
  function reveal(el, cls) {
    if (!el) return;
    el.hidden = false;
    void el.offsetWidth;              // flush layout — do not remove
    el.classList.add(cls || 'is-open');
  }

  /* ======================================================================
     CART  →  Kalles: sections/mini_cart.liquid  (cart_type = "drawer")

     ONE drawer, TWO backends, chosen once at load:

       LOCAL    the static build (mockup/, Vercel). No backend exists, so the
                bag lives in localStorage — unchanged since HANDOFF §17.
       SHOPIFY  inside the Shopify theme (HANDOFF §35). Detected by the
                `Shopify.shop` global that content_for_header defines on
                every storefront page and that no static page has. The same
                drawer then reads and writes Shopify's real Ajax Cart API:
                /cart.js, /cart/add.js, /cart/change.js. There is no
                localStorage copy in this mode — Shopify's cart is the state.

     Both backends hand cartPaint() the same view model, so the drawer markup
     and styling are identical either way:
         { lines: [{ key, href, title, image, size, qty, line }], subtotal }
       key    LOCAL: handle + '::' + size.  SHOPIFY: the cart line's own key.
       line   line total in PKR (a number). Formatted at render time only.

     LOCAL SCHEMA — localStorage["remy.cart.v1"] = JSON array of line items:
         { handle, title, image, price, size, qty }
       handle  product handle — the stable identity. NOT the title: 11
               products share a title across 3 groups (HANDOFF §5), so
               titles cannot key anything.
       price   unit price, a NUMBER in PKR. Formatted at render time only.
       size    the chip's own normalised label, verbatim from data-size.
               Ladders differ per product (18 raw spellings, 2-6 sizes), so
               nothing here assumes a fixed ladder.
       qty     integer >= 1.
     A LINE is identified by handle + size — the same product in two sizes is
     two lines. The PDP href is derived, not stored: product-<handle>.html,
     the one convention spelled out in build/asset_map.py pdp_href().

     Everything is defensive: a corrupt or unreadable store — or a failed
     /cart.js — degrades to an empty bag rather than throwing on page load,
     because this init runs on EVERY page just to paint the header badge.
     ====================================================================== */
  var CART_KEY = 'remy.cart.v1';
  var SHOP = !!(window.Shopify && window.Shopify.shop);
  var SHOP_ROOT = (SHOP && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartLines = [];                  // last painted view model, for qty steps

  function cartRead() {
    try {
      var raw = localStorage.getItem(CART_KEY);
      if (!raw) return [];
      var items = JSON.parse(raw);
      if (!Array.isArray(items)) return [];
      // keep only well-formed lines; a half-written store must not break a page
      return items.filter(function (i) {
        return i && typeof i.handle === 'string' && i.handle &&
               typeof i.size === 'string' &&
               isFinite(i.price) && isFinite(i.qty) && i.qty > 0;
      }).map(function (i) {
        return {
          handle: i.handle, title: String(i.title || i.handle),
          image: String(i.image || ''), price: Number(i.price),
          size: i.size, qty: Math.max(1, Math.min(99, Math.floor(i.qty)))
        };
      });
    } catch (e) { return []; }        // private mode, quota, corrupt JSON
  }

  function cartWrite(items) {
    try { localStorage.setItem(CART_KEY, JSON.stringify(items)); }
    catch (e) { /* storage unavailable: the bag is in-memory for this page */ }
    cartPaint(localView(items));
  }

  function pdpHref(handle) { return 'product-' + handle + '.html'; }

  function localView(items) {
    var lines = items.map(function (i) {
      return { key: i.handle + '::' + i.size, href: pdpHref(i.handle), title: i.title,
               image: i.image, size: i.size, qty: i.qty, line: i.price * i.qty };
    });
    return { lines: lines, subtotal: lines.reduce(function (n, l) { return n + l.line; }, 0) };
  }

  // build/normalize_sizes.py, in JS: a Shopify cart line carries the RAW
  // variant title ('7-8YEARS', '11- 12 Years'), the chips print the
  // normalised one. The drawer must say what the chip said.
  function normSize(raw) {
    var m = /^\s*(\d+)\s*-\s*(\d+)\s*(?:y|yr|yrs|year|years)?\s*$/i.exec(String(raw || ''));
    return m ? (parseInt(m[1], 10) + '-' + parseInt(m[2], 10) + ' Years')
             : String(raw || '').replace(/\s+/g, ' ').trim();
  }

  function shopView(cart) {
    var lines = ((cart && cart.items) || []).map(function (it) {
      var raw = it.options_with_values && it.options_with_values[0]
                ? it.options_with_values[0].value : it.variant_title;
      return { key: it.key, href: it.url, title: it.product_title,
               image: it.image || '', size: normSize(raw), qty: it.quantity,
               line: it.final_line_price / 100 };       // Ajax API money is in cents
    });
    return { lines: lines, subtotal: ((cart && cart.total_price) || 0) / 100 };
  }

  function shopFetch(path, body) {
    return fetch(SHOP_ROOT.replace(/\/$/, '') + path, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    } : { headers: { 'Accept': 'application/json' } }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || r.status); e.data = j; throw e; }
        return j;
      });
    });
  }

  function shopRefresh() {
    return shopFetch('/cart.js').then(function (c) { cartPaint(shopView(c)); })
      .catch(function () { cartPaint({ lines: [], subtotal: 0 }); });
  }

  // Matches the price format the rest of the site prints: Rs.1,748.00 PKR
  function money(n) {
    return 'Rs.' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' PKR';
  }

  /* ---- header badge: runs on EVERY page, drawer present or not ---------- */
  function cartPaint(view) {
    cartLines = view.lines;
    var n = view.lines.reduce(function (s, l) { return s + l.qty; }, 0);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = String(n);
      el.hidden = n === 0;            // no "0" badge on an empty bag
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-open]'), function (el) {
      el.setAttribute('aria-label', 'Bag, ' + n + ' item' + (n === 1 ? '' : 's'));
    });
    var lbl = document.querySelector('[data-cart-count-label]');
    if (lbl) lbl.textContent = '(' + n + ')';
    cartRenderLines(view);
  }

  /* ---- drawer contents -------------------------------------------------- */
  function cartRenderLines(view) {
    var list = document.querySelector('[data-cart-items]');
    if (!list) return;                       // page without the drawer shell
    var empty = document.querySelector('[data-cart-empty]');
    var foot  = document.querySelector('[data-cart-foot]');
    var sub   = document.querySelector('[data-cart-subtotal]');

    list.innerHTML = '';
    view.lines.forEach(function (i) {
      var li = document.createElement('li');
      li.className = 'cline';
      li.setAttribute('data-line', i.key);
      li.innerHTML =
        '<a class="cline__media" href="' + esc(i.href) + '" tabindex="-1" aria-hidden="true">' +
          (i.image ? '<img src="' + esc(i.image) + '" alt="">' : '') +
        '</a>' +
        '<div class="cline__main">' +
          '<a class="cline__name" href="' + esc(i.href) + '">' + esc(i.title) + '</a>' +
          '<p class="cline__size">Size: ' + esc(i.size) + '</p>' +
          '<p class="cline__price">' + esc(money(i.line)) + '</p>' +
          '<div class="cline__foot">' +
            '<div class="qty">' +
              '<button class="qty__btn" type="button" data-qty="-1" aria-label="Decrease quantity"' +
                 (i.qty <= 1 ? ' disabled' : '') + '>&minus;</button>' +
              '<span class="qty__val">' + i.qty + '</span>' +
              '<button class="qty__btn" type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="cline__remove" type="button" data-remove>Remove</button>' +
          '</div>' +
        '</div>';
      list.appendChild(li);
    });

    var has = view.lines.length > 0;
    if (empty) empty.hidden = has;
    if (foot) foot.hidden = !has;
    if (sub) sub.textContent = money(view.subtotal);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- mutations -------------------------------------------------------- */
  function cartAdd(line) {
    var items = cartRead();
    var found = null;
    for (var k = 0; k < items.length; k++) {
      if (items[k].handle === line.handle && items[k].size === line.size) { found = items[k]; break; }
    }
    if (found) found.qty = Math.min(99, found.qty + line.qty);
    else items.push(line);
    cartWrite(items);
    return items;
  }

  function cartMutate(key, fn) {
    var items = cartRead(), out = [];
    items.forEach(function (i) {
      if (i.handle + '::' + i.size !== key) { out.push(i); return; }
      var next = fn(i);
      if (next) out.push(next);
    });
    cartWrite(out);
  }

  // One entry point per action, whichever backend is live. The SHOPIFY path
  // repaints from the cart Shopify returns, so the drawer always shows what
  // Shopify actually holds — including when it caps a quantity at stock.
  var cartBusy = false;
  function cartSetQty(key, qty) {
    if (!SHOP) {
      cartMutate(key, function (i) {
        if (qty <= 0) return null;
        i.qty = Math.max(1, Math.min(99, qty));
        return i;
      });
      return;
    }
    if (cartBusy) return;
    cartBusy = true;
    if (drawer) drawer.setAttribute('aria-busy', 'true');
    shopFetch('/cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .then(function (c) { cartPaint(shopView(c)); })
      .catch(function () { return shopRefresh(); })
      .then(function () {
        cartBusy = false;
        if (drawer) drawer.removeAttribute('aria-busy');
      });
  }

  function cartLine(key) {
    for (var k = 0; k < cartLines.length; k++) if (cartLines[k].key === key) return cartLines[k];
    return null;
  }

  /* ---- drawer open / close ---------------------------------------------- */
  var drawer = document.getElementById('cart-drawer');
  var cartScrim = document.querySelector('.cart-scrim');   // NOT `scrim` — see the mobile-nav note above
  var cartLastFocus = null;

  function cartOpen() {
    if (!drawer) return;
    cartLastFocus = document.activeElement;
    if (cartScrim) reveal(cartScrim);
    reveal(drawer);
    document.body.style.overflow = 'hidden';
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-open]'), function (el) {
      el.setAttribute('aria-expanded', 'true');
    });
    var close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  function cartClose() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    if (cartScrim) cartScrim.classList.remove('is-open');
    document.body.style.overflow = '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-open]'), function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
    // wait out the slide-out before taking it off the a11y tree
    setTimeout(function () {
      if (drawer.classList.contains('is-open')) return;   // reopened meanwhile
      drawer.hidden = true; if (cartScrim) cartScrim.hidden = true;
    }, 320);
    if (cartLastFocus && cartLastFocus.focus) cartLastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); cartOpen(); return; }
    if (e.target.closest('[data-cart-close]')) { cartClose(); return; }

    var qty = e.target.closest('[data-qty]');
    if (qty) {
      var line = qty.closest('[data-line]');
      var cur = line && cartLine(line.getAttribute('data-line'));
      var step = parseInt(qty.getAttribute('data-qty'), 10);
      if (cur) cartSetQty(cur.key, Math.max(1, Math.min(99, cur.qty + step)));
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      var rline = rm.closest('[data-line]');
      if (rline) cartSetQty(rline.getAttribute('data-line'), 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) cartClose();
  });

  /* ---- ADD TO BAG (PDP) -------------------------------------------------
     Refuses on no selection and on a sold-out size. Sold-out chips are
     `disabled` and carry no data-size / data-variant-id (decision #2), so
     they cannot be the active chip and cannot be read as one. In SHOPIFY
     mode the chip's variant id goes to /cart/add.js; a refusal from Shopify
     (e.g. the size sold out since the page rendered) is shown inline, in
     Shopify's own words, and the drawer does not open. ------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-add-to-cart]'), function (btn) {
    btn.addEventListener('click', function () {
      var root = btn.closest('[data-product]');
      if (!root) return;
      var msg = root.querySelector('[data-add-msg]');
      function say(text, err) {
        if (!msg) return;
        msg.textContent = text;
        msg.hidden = false;
        msg.className = 'pdp__addmsg' + (err ? ' pdp__addmsg--err' : '');
      }

      var chip = root.querySelector('.size-chip.is-active:not([disabled])');
      var size = chip && chip.getAttribute('data-size');
      if (!size) { say('Choose a size first.', true); return; }

      if (SHOP) {
        var id = parseInt(chip.getAttribute('data-variant-id'), 10);
        if (!id || btn.disabled) { if (!id) say('Choose a size first.', true); return; }
        btn.disabled = true;
        shopFetch('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
          .then(function () { return shopRefresh(); })
          .then(function () { say('Added ' + size + ' to your bag.', false); cartOpen(); })
          .catch(function (err) { say(err.message || 'Could not add to your bag. Please try again.', true); })
          .then(function () { btn.disabled = false; });
        return;
      }

      cartAdd({
        handle: root.getAttribute('data-handle'),
        title:  root.getAttribute('data-title'),
        image:  root.getAttribute('data-image'),
        price:  parseFloat(root.getAttribute('data-price')) || 0,
        size:   size,
        qty:    1
      });
      say('Added ' + size + ' to your bag.', false);
      cartOpen();
    });
  });

  if (SHOP) {
    shopRefresh();      // every page, on load
  } else {
    /* Another tab changed the bag — keep this one honest. */
    window.addEventListener('storage', function (e) {
      if (e.key === CART_KEY) cartPaint(localView(cartRead()));
    });
    cartPaint(localView(cartRead()));          // every page, on load
  }


  /* ======================================================================
     INSTANT SEARCH  →  Kalles: sections/search-hidden.liquid

     The live header search drops a hidden panel and suggests as you type
     (settings_data.json: show_search_suggest = true). Same behaviour, run
     against search-index.js — the 91 real products, generated by
     build/render_search_index.py from data/remy-products.json.

     Matching is on TITLE + CATEGORY: entry.k is the lowercased title plus
     every collection title the product belongs to, so "polo", "eastern",
     "tank top" and "girls" all find things whose titles never say so.
     Every query word must match somewhere (AND), so "girls jeans" narrows
     instead of widening.

     Results are real .pcard links to product-<handle>.html. A query that
     matches nothing still offers real collections — no dead end.
     ====================================================================== */
  var searchPanel = document.getElementById('search-overlay');
  var searchIndex = window.REMY_SEARCH || [];

  if (searchPanel) {
    var sInput   = searchPanel.querySelector('[data-search-input]');
    var sResults = searchPanel.querySelector('[data-search-results]');
    var sMeta    = searchPanel.querySelector('[data-search-meta]');
    var sNone    = searchPanel.querySelector('[data-search-none]');
    var sEcho    = searchPanel.querySelector('[data-search-echo]');
    var sScrim   = document.querySelector('.search-scrim');
    var sLast    = null;
    var SEARCH_MAX = 24;

    function searchOpen() {
      sLast = document.activeElement;
      if (sScrim) reveal(sScrim);
      reveal(searchPanel);
      document.body.style.overflow = 'hidden';
      Array.prototype.forEach.call(document.querySelectorAll('[data-search-open]'), function (el) {
        el.setAttribute('aria-expanded', 'true');
      });
      sInput.focus();
      sInput.select();
    }

    function searchClose() {
      if (searchPanel.hidden) return;
      searchPanel.classList.remove('is-open');
      if (sScrim) sScrim.classList.remove('is-open');
      document.body.style.overflow = '';
      Array.prototype.forEach.call(document.querySelectorAll('[data-search-open]'), function (el) {
        el.setAttribute('aria-expanded', 'false');
      });
      setTimeout(function () {
        if (searchPanel.classList.contains('is-open')) return;
        searchPanel.hidden = true;
        if (sScrim) sScrim.hidden = true;
      }, 260);
      if (sLast && sLast.focus) sLast.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); searchOpen(); return; }
      if (e.target.closest('[data-search-close]')) { searchClose(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hidden) searchClose();
    });

    function runSearch(q) {
      q = String(q || '').trim();
      sResults.innerHTML = '';
      if (!q) {
        sMeta.textContent = searchIndex.length + ' products to search';
        sNone.hidden = true;
        return;
      }
      var words = q.toLowerCase().split(/\s+/).filter(Boolean);
      var hits = searchIndex.filter(function (e) {
        for (var i = 0; i < words.length; i++) {
          if (e.k.indexOf(words[i]) === -1) return false;   // AND across words
        }
        return true;
      });

      if (!hits.length) {
        sMeta.textContent = 'No results';
        if (sEcho) sEcho.textContent = '"' + q + '"';
        sNone.hidden = false;
        return;
      }
      sNone.hidden = true;
      var shown = hits.slice(0, SEARCH_MAX);
      sMeta.textContent = hits.length + ' result' + (hits.length === 1 ? '' : 's')
        + (hits.length > shown.length ? ' — showing ' + shown.length : '');

      var frag = document.createDocumentFragment();
      shown.forEach(function (e) {
        var a = document.createElement('a');
        a.className = 'pcard search__hit';
        a.href = 'product-' + e.h + '.html';
        a.setAttribute('data-handle', e.h);
        a.innerHTML =
          '<div class="pcard__media"><img src="' + esc(e.i) + '" alt="' + esc(e.t) + '" loading="lazy"></div>' +
          '<h3 class="pcard__name">' + esc(e.t) + '</h3>' +
          '<p class="pcard__price">' + esc(money(e.p)) + '</p>' +
          '<p class="search__cat">' + esc(e.c) + '</p>';
        frag.appendChild(a);
      });
      sResults.appendChild(frag);
    }

    sInput.addEventListener('input', function () { runSearch(sInput.value); });
    // Enter should not reload the page — there is no /search results page.
    sInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });
    runSearch('');
  }


  /* ======================================================================
     ANNOUNCEMENT BAR  →  Kalles: sections/announcement-bar.liquid

     The live bar is a Flickity carousel whose own config reads
     autoPlay 3500, wrapAround, pauseAutoPlayOnHover and a fade effect.
     Those four settings are reproduced here in plain JS — 3.5s dwell,
     wrap-around, pause on hover/focus, crossfade (the fade itself is CSS).

     The markup is shared header chrome on every page, so this is wired
     ONCE against [data-announce]. With JS off, or with a single message,
     nothing runs and the first message simply stays put.

     The live site also splits these three strings across two sections
     (announcement-bar carousel + a separate static top-bar); this build
     consolidates them into one strip. See the comment in the markup.
     ====================================================================== */
  var announce = document.querySelector('[data-announce]');
  if (announce) {
    var aMsgs = announce.querySelectorAll('.announce__msg');
    if (aMsgs.length > 1) {
      var A_DWELL = 3500;                 // live carousel's autoPlay value
      var aAt = 0, aTimer = null;

      function aShow(n) {
        aAt = (n + aMsgs.length) % aMsgs.length;      // wrapAround
        Array.prototype.forEach.call(aMsgs, function (m, i) {
          var on = i === aAt;
          m.classList.toggle('is-current', on);
          // Only the visible message is exposed; the bar is not a live
          // region, so a rotation never interrupts a screen reader.
          if (on) m.removeAttribute('aria-hidden');
          else m.setAttribute('aria-hidden', 'true');
        });
      }
      function aStart() {
        if (aTimer) return;
        aTimer = setInterval(function () { aShow(aAt + 1); }, A_DWELL);
      }
      function aStop() {
        if (!aTimer) return;
        clearInterval(aTimer); aTimer = null;
      }

      // pauseAutoPlayOnHover, plus the keyboard equivalent
      announce.addEventListener('mouseenter', aStop);
      announce.addEventListener('mouseleave', aStart);
      announce.addEventListener('focusin', aStop);
      announce.addEventListener('focusout', aStart);
      // Stop ticking once the tab is hidden, and resume when it comes back.
      // Note this deliberately does NOT check document.hidden up front: a
      // page can load while already hidden (Chrome also reports hidden for
      // an occluded window), and refusing to start there would leave the bar
      // frozen on message 1 with no event coming to un-freeze it.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) aStop(); else aStart();
      });

      aShow(0);
      aStart();
    }
  }

  /* ---- ANIMATION SCAFFOLDING -------------------------------------------
     Elements carrying .reveal-on-scroll are the intended scroll-reveal
     targets. No observer is wired up in this pass by design — the markup
     hook exists so the behaviour can be added later without restructuring
     any HTML. Everything stays fully visible until then.
     ---------------------------------------------------------------------- */
}());
